/**
 * Which family's version of the invitation this is.
 * sonakaraj.com             -> "bride" (Sonakshi first, the default)
 * sonakaraj.com/?side=bride -> "bride", and RSVP preselects Bride's side
 * sonakaraj.com/?side=groom -> "groom" (Shubham first), RSVP preselects Groom's side
 * Only the order of names and the Swagatotsuk hosts change; the
 * Alliance section stays the same in both.
 */
const param = typeof window === "undefined" ? null : new URLSearchParams(window.location.search).get("side");

export const SIDE = param === "groom" ? "groom" : "bride";
export const IS_GROOM = SIDE === "groom";
// RSVP "side" to preselect: only when the link names a side explicitly
export const RSVP_SIDE = param === "groom" ? "Groom's side" : param === "bride" ? "Bride's side" : "";

// "Sonakshi & Shubham" or "Shubham & Sonakshi"
export const NAMES = IS_GROOM ? ["Shubham", "Sonakshi"] : ["Sonakshi", "Shubham"];
export const NAMES_TEXT = `${NAMES[0]} & ${NAMES[1]}`;
